import styled from 'styled-components'
import { rem } from 'polished'

const ResetButtonWrapper = styled.div`
  text-align: left;
`

const ResetButton = styled.button`
  cursor: pointer;
  border: 0;
  padding: 10px 5px;
  line-height: 1.2;
  background: none;
  text-transform: uppercase;
  text-decoration: underline;
  user-select: none;
  font-size: ${(props) => rem(props.theme.fontSizes[2])};
  display: ${(props) => (props.disabled ? 'block' : 'inline-block')};
  pointer-events: ${(props) => (props.disabled ? 'none' : 'auto')};
  transition: color 0.3s ${(props) => props.theme.ease.ease_out_expo};
  color: ${(props) =>
    props.active ? props.theme.colors.blue : props.theme.colors.grey_light};

  &:hover {
    color: ${(props) => props.theme.colors.blue_dark};
    outline: 0;
  }
`

export { ResetButton, ResetButtonWrapper }
